import React from 'react';
import styled from 'styled-components';

const DEFAULT_IMG = 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=400&q=80';

// Reusable "Our Services" subcategory card with a large, prominent image.
// Props: { image, title, tag, onClick }
const ServiceItem = ({ image, title, tag = 'Explore →', onClick }) => (
  <Card onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onClick?.()}>
    <ImgWrap>
      <Img
        src={image || DEFAULT_IMG}
        alt={title}
        loading="lazy"
        onError={(e) => { e.target.src = DEFAULT_IMG; }}
      />
      <Tag>{tag}</Tag>
    </ImgWrap>
    <Title>{title}</Title>
  </Card>
);

export default ServiceItem;

const Card = styled.div`
  background: #ffffff;
  border: 1px solid #f1f5f9;
  border-radius: 20px;
  padding: 14px 14px 18px;
  text-align: center;
  cursor: pointer;
  height: 100%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.03);
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.4s ease, border-color 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    border-color: #e2e8f0;
  }
`;

const ImgWrap = styled.div`
  position: relative;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 16px;
`;

const Img = styled.img`
  width: 100%;
  height: 190px;
  object-fit: cover;
  display: block;
  transition: transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  ${Card}:hover & {
    transform: scale(1.08);
  }

  @media (max-width: 1199px) {
    height: 170px;
  }
  @media (max-width: 767px) {
    height: 200px;
  }
`;

const Tag = styled.span`
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: rgba(8, 33, 137, 0.92);
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  padding: 5px 12px;
  border-radius: 20px;
  opacity: 0;
  transform: translateY(6px);
  transition: opacity 0.3s ease, transform 0.3s ease;

  ${Card}:hover & {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Title = styled.h6`
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.4px;
`;
